import i from "react";
import { useTheme as r, Divider as o } from "@mui/material";
const m = (e) => {
  const t = r();
  return /* @__PURE__ */ i.createElement(
    o,
    {
      id: e.id,
      orientation: e.orientation,
      sx: {
        borderColor: e.emphasis === "low" ? t.palette.grey[200] : "inherit"
      }
    }
  );
};
export {
  m as D
};
